module.exports = {"pathContext":{"name":"AnalyticsData","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"data","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"AnalyticsDataRow","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"field","type":{"kind":"ENUM","name":"AnalyticsField","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-analytics-data.json
// module id = 1649
// module chunks = 251060473113344